<lib-dropdown
  [hasMinWidth]="false"
  [showSelectedTick]="false"
  [options]="[
    {
      value: UrgencyOption.Low,
      label: 'charting_treatment_urgency_low' | translate,
      itemOverviewClass: '!text-states-mid-blue',
      itemSelectedClass: '!text-states-mid-blue'
    },
    {
      value: UrgencyOption.Medium,
      label: 'charting_treatment_urgency_medium' | translate,
      itemOverviewClass: '!text-states-orange',
      itemSelectedClass: '!text-states-orange'
    },
    {
      value: UrgencyOption.High,
      label: 'charting_treatment_urgency_high' | translate,
      itemOverviewClass: '!text-states-red',
      itemSelectedClass: '!text-states-red'
    }
  ]"
  [value]="value"
  (valueChange)="onUrgencyChange($event)"
/>
